export default {
  banner: {
    code: "Identifiant spécifique pour la cible d'une bannière",
    name: 'Titre de la bannière',
    status: 'Statut de la bannière, la bannière est soit activée, soit désactivée',
    content: 'Contenu des bannières, vous pouvez générer du contenu dans la langue de votre choix.',
    ctatext: 'Contenu ctatext, vous pouvez générer du contenu pour la langue de votre choix',
    ctalink: "Ctalink est un champ dédié sans restriction d'écriture (fonctionnalités avancées)",
    ctaonclick: "Ctaonclick est un champ dédié sans restriction d'écriture",
    url: "L'url permettra de localiser l'endroit où mettre en œuvre la bannière",
    url_target: "Url_target sera une regex configurée pour cibler l'url plus facilement",
    frequencylimitation: 'Frequencylimitation nous permettra de savoir à quelle fréquence nous devons afficher la bannière',
    frequencylimitationvalue: "Frequencylimitationvalue est une valeur qui nous indiquera la fréquence d'affichage => 1 pour un temps",
    activationdate: 'Date à laquelle la bannière commencera a être affichée',
    deactivationdate: 'Date à laquelle la bannière finira d"être affichée'
  }
}



// WEBPACK FOOTER //
// ./src/translations/fr/tooltip.js